import moment from "moment";

const defaultProductsToAdjust = JSON.stringify([])
export const PRODUCT_TO_ADJUST_STORE_KEY = 'productsToAdjust'
export const PRODUCT_TO_ADJUST_CREATION_DATE_STORE_KEY = 'productsToAdjustCreatedAt'

export const saveProductsToAdjust = (products: any[]) => {
    const oldProducts = JSON.parse(localStorage.getItem(PRODUCT_TO_ADJUST_STORE_KEY) || defaultProductsToAdjust);
    localStorage.setItem(PRODUCT_TO_ADJUST_STORE_KEY, JSON.stringify(products))
}

export const getProductsToAdjust = () => {
    return JSON.parse(localStorage.getItem(PRODUCT_TO_ADJUST_STORE_KEY) || defaultProductsToAdjust);
}

export const clearProductsToAdjustCreatedAt = () => {
    localStorage.setItem(PRODUCT_TO_ADJUST_CREATION_DATE_STORE_KEY, '0')
}
export const setProductsToAdjustCreatedAt = () => {
    localStorage.setItem(PRODUCT_TO_ADJUST_CREATION_DATE_STORE_KEY, JSON.stringify(moment().toDate()))
}

export const getProductsToAdjustCreatedAt = () => {
    return JSON.parse(localStorage.getItem(PRODUCT_TO_ADJUST_CREATION_DATE_STORE_KEY) || '0');
}